<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="4" md="6">
          <stats-card title="Tiendas "
                      type="gradient-red"
                      sub-title=""
                      icon=""
                      class="">

            <template slot="footer">
              <b-form-select size="sm" v-model="filter.tienda" :options="selectTienda" ></b-form-select>
              <!--<span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>-->
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Fecha"
                      type="gradient-orange"
                      sub-title=""
                      icon=""
                      class="">

            <template slot="footer">
              <b-form-input size="sm" class="form-control" v-model="filter.fecha" type="date" value="2021-01-04" id="example-date-input"></b-form-input>
              <!--<span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>-->
            </template>
          </stats-card>
        </b-col>
        <b-col xl="2" md="6">
          <stats-card title="Buscar"
                      type="gradient-green"
                      sub-title=""
                      icon=""
                      class="">

            <template slot="footer">
              <b-button size="sm" @click="buscarDatos()" block  variant="success"><i class="fas fa-search-dollar"></i></b-button>
              <!--<span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>-->
            </template>
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Cierre Total"
                      type="gradient-info"
                      sub-title=""
                      icon=""
                      class="mb-4">

            <template slot="footer">
              <b-button size="sm" @click="cierreTotal()" block  variant="success">cierre Caja</b-button>
              <b-button size="sm" @click="cierreTurnos()" block  variant="success">Turnos Procesados</b-button>
              <!--<span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>-->
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
        <b-card no-body>
            <b-card-header class="border-0">
                <h3 class="mb-0">Desglose Factura General</h3>
            </b-card-header>
            <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-center">
                      <tbody>
                        <tr class="thead-light">                            
                            <th>Documento</th>                            
                           <!-- <th>Fact. Al Mayor</th>-->
                            <th>Fecha/Hora</th>
                            <th>Nro Factura</th>
                            <th>Monto General Bs</th>
                            <th>Tasa</th>
                            <th>Estatus</th>                     
                            <th>Acciones</th>
                      </tr>
                      <tr v-for="factura in facturas" :key="factura.id">                        
                        <td>{{factura.numeroControl}}</td>                    
                        <!--<td>{{zfill(factura.consecutivo, 6)}}</td>
                        <td><span :class="{'badge badge-danger':!factura.facturaAlMayor, 'badge badge-success':factura.facturaAlMayor }">{{factura.facturaAlMayor | factmy}}</span></td>-->
                        <td>{{factura.fecha | myDateTime}}</td>
                        <td>{{factura.numeroFactura}}</td>
                        <td class="text-right">{{factura.montoPagadobs | moneda}}</td>
                        <td class="text-right">{{factura.tasa | moneda}}</td>
                        <td><span :class="{'badge badge-danger':factura.estatus===4, 'badge badge-warning':factura.estatus===3, 'badge badge-success':factura.estatus===1,'badge badge-default':factura.estatus===0 }">{{factura.estatus | statusFactura}}</span></td>                        
                        <td>
                            <base-button size="sm" type="secondary" title="Ver Factura" 
                            @click="verDetalleFactura(factura)"
                            :class="{'disabled':(factura.estatus == -1 || factura.estatus == 0)}">
                                <i class="fa fa-tasks"></i>
                            </base-button>                        
                            <base-button size="sm" type="warning" @click="editModal(factura)">
                                <i class="fa fa-edit"></i>
                            </base-button>                        
                            <base-button size="sm" type="danger" @click="deletefactura(factura.id)">
                                <i class="fa fa-trash"></i>
                            </base-button>
                        </td>
                      </tr>
                    </tbody></table>
                <!-- /.card -->
            </div>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="5" :total="5"></base-pagination>
            </b-card-footer>
        </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>

    <!-- Modal Detalle Producto-->
    <b-modal ref="modal-detalleProducto" size="md" title="Detalle de Factura" ok-only>
      <b-list-group-item href="javascript:;" class=" flex-column align-items-start py-4 px-4">
        <div class="d-flex w-100 justify-content-between">
          <div>
            <div class="d-flex w-100 align-items-center">
              <img src="img/theme/producto.png" alt="Image placeholder" class="avatar avatar-xs mr-2">
              <h5 class="mb-1">{{productoActual.descripcion}}</h5>
            </div>
          </div>
          <small>Fecha: {{productoActual.fecha | myDate}}</small>
        </div>
        <h4 class="mt-3 mb-1">Código: {{productoActual.codigoProducto }}</h4>
        <b-list-group flush>
          <b-list-group-item href="#">Precio: {{productoActual.precioBolivar | moneda}} Bs.</b-list-group-item>
          <b-list-group-item href="#">Precio: {{productoActual.precioDolar | moneda}} $</b-list-group-item>
          <b-list-group-item href="#">Tasa: {{productoActual.tasa}} Bs.</b-list-group-item>
        </b-list-group>        
      </b-list-group-item>
    </b-modal>

      <!-- Detalle pago -->
      <b-modal ref="modal-DetalleFactura" hide-backdrop  size="lg" ok-only>
        <template #modal-title>
          <h5 class="modal-title">Detalle de Factura</h5>        
        </template>
        <p>
          <!--Total Dolares: {{detalleMoneda[0].totalMoneda | moneda}} - Total Bolivares: {{detalleMoneda[1].totalMoneda | moneda}}
          <b-button v-b-modal.modal-multi-3 size="sm">Open Third Modal</b-button>-->
        </p>
        <table width="100%" class="detallefactura table-bordered">
          <tr>
            <th width="12%">Documento:</th>
            <td><b>{{facturaActual.numeroControl}}</b></td>
            <th>Tasa:</th>
            <td class="fondotasa text-right">{{facturaActual.tasa | moneda}} Bs.</td>
          </tr>
          <tr>
            <th>Cliente:</th>
            <td colspan="3">{{detalleDeFactura.cliente.nombre}} {{detalleDeFactura.cliente.apellido}}</td>
          </tr>
          <tr>
            <th>RIF/C.I:</th>
            <td>{{detalleDeFactura.cliente.cedRif}}</td>
            <th>Cod. Afil.:</th>
            <td>00999</td>
          </tr>
          <tr>
            <th>Dir.:</th>
            <td colspan="3">{{detalleDeFactura.cliente.direccion}}</td>
          </tr>
          <tr>
            <th>Cajero:</th>
            <td>{{cajero.nombre}} {{cajero.apellido}}</td>
            <th>Caja:</th>
            <td>{{facturaActual.caja}}</td>
          </tr>
          <tr>
            <th>Factura:</th>
            <td colspan="3"><b>{{facturaActual.numeroFactura}}</b></td>
          </tr>
          <tr>
            <th>Fecha:</th>
            <td colspan="3">{{facturaActual.fecha | myDateTime}}</td>
          </tr>
        </table>
        <table class="table table-hover table-bordered">
          <tr class="thead-light">
            <th style="width:50px;">DESCRIPCION</th>
            <th>CANT</th>
            <th>PRECIO</th>
            <th>TOTAL</th>
          </tr>
          <tbody>
          <tr v-for="df in detalleDeFactura.detalleFactura" :key="df.codigoProducto" @click="verDetalleProducto(df)">
            <td>{{df.descripcion}}</td>
            <td>{{df.cantidad}}</td>
            <td class="text-right">{{df.precioBolivar | moneda}}</td>
            <td class="text-right">{{df.total | moneda}}</td>
          </tr>
          </tbody>
          <tr>
            <th colspan="3" scope="row">SUBTOTAL</th>
            <td class="text-right">{{totalGeneralBs | moneda}}</td>
          </tr>
          <tr>
            <th colspan="3" scope="row">IMPUESTO</th>
            <td class="text-right">{{facturaActual.montoIVAbs | moneda}}</td>
          </tr>
          <tr v-if="facturaActual.montoDescuentobs>0">
            <th colspan="3" scope="row">DESCUENTO</th>
            <td class="text-right">- {{facturaActual.montoDescuentobs | moneda}}</td>
          </tr>          
          <tr>
            <th colspan="3" scope="row">TOTAL</th>
            <td class="text-right bckgmontobs">{{facturaActual .montoPagadobs| moneda}}</td>
          </tr>
        </table>        
        <template #modal-footer="{ close }">
          <div class="w-100">          
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="close()"
            >
              Cerrar
            </b-button>
          </div>
        </template>
      </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,
      detalleDeFactura:{
        cliente: {
          apellido: "",
          cedRif: "",
          direccion: "",
          nombre: "",
          telefono: ""}        
        ,detalleFactura:[]},
      cajero:{
          accionesAdc: null,
          apellido: "",
          cedula: "",
          createdAt: "",
          estatus: 1,
          id: 1,
          nick: "",
          nombre: "",
          password: "",
          rolId: 0,
          sucursal: 0,
          tipo: 0,
          updatedAt: "",         
      },
      monedaSelect:1,
      tipoMoneda:[{id:1, detalle:'Bs.'},{id:2, detalle:'$'}],//1:Bolivar, 2:Dolar
      facturas:[],
      facturaActual:{},
      productoActual:{},
      filter: new Form({
        turno: 0,
        tiendaId: 0,
        codigoCaja: '',
        areaId: '',
        fecha:'',
        monto: 0,
        estatus: 0,
      }),
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        factMayor: [{value:true, text:"Si"}, {value:false, text:"No"}],
        selectTienda:[{value:"", text:"Seleccione"}]
      };
    },
    methods: {
      verDetalleFactura: async function(factura){
        this.facturaActual = factura;
        console.log(factura)
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFactura?Factura="+factura.numeroFactura+"&Fecha="+factura.fecha).then(({ data }) => {this.detalleDeFactura = data.data; console.log(this.detalleDeFactura ) });
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+factura.turno).then(({ data }) => {this.cajero = data.data.cajeraTurno; console.log(this.cajero) });
        this.$refs['modal-DetalleFactura'].show();        
      },
      verDetalleProducto(df){
        this.productoActual = df;
        this.$refs['modal-detalleProducto'].show();
      },
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      getHora(){
        var currentDate = new Date();
        var hora = currentDate.getHours();
        var min = currentDate.getMinutes();
        //var seg = currentDate.getSeconds();
        return (hora<10?("0"+hora):hora)+":"+(min<10?("0"+min):min);
      },      
      calculardiferencia(hora_desde="12:00T12:00"){
        var hora_inicio = hora_desde.split("T")[1];
        hora_inicio = hora_inicio.slice(0, 5);
        //var hora_iniciop = hora_desde;
        var hora_final = this.getHora();

        if(hora_desde > hora_final){          
          hora_inicio = hora_final;
          hora_final = hora_desde;
        }        

        
        // Expresión regular para comprobar formato
        var formatohora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        
        // Si algún valor no tiene formato correcto sale
        if (!(hora_inicio.match(formatohora)
              && hora_final.match(formatohora))){
          return;
        }
        
        // Calcula los minutos de cada hora
        var minutos_inicio = hora_inicio.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        var minutos_final = hora_final.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        
        // Si la hora final es anterior a la hora inicial sale
        if (minutos_final < minutos_inicio) return;
        
        // Diferencia de minutos
        var diferencia = minutos_final - minutos_inicio;
        
        // Cálculo de horas y minutos de la diferencia
        var horas = Math.floor(diferencia / 60);
        var minutos = diferencia % 60;
        
        return horas + ':' + (minutos < 10 ? '0' : '') + minutos;  
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */ 
          var zero = "0"; /* String de cero */  
          
          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString()); 
              } else {
                  return numberOutput.toString(); 
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString()); 
              }
          }
      },
      loadFacturas(){
        if (this.$route.query.hasOwnProperty('turno') && this.$route.query.hasOwnProperty('caja')) {
          this.filter.turno = this.$route.query.turno;
          this.filter.codigoCaja = this.$route.query.caja;
        }
        if(this.$route.query.hasOwnProperty('fecha')){
            this.filter.fecha = this.$route.query.fecha;
        }
        
        //if(this.$gate.isAdminOrAuthor()){
        axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ListadoFactura?Fecha="+this.filter.fecha+"&Turno="+this.filter.turno+"&Caja="+this.filter.codigoCaja).then(({ data }) => {this.facturas = data.data; });

          //axios.get("https://localhost:44345/api/Tienda").then(({ data }) => {this.tiendas = data; this.getSelectTienda(); });
          
        //}
      },

    },
    computed: {
      totalGeneralBs: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseInt(val.precioBolivar) * parseInt(val.cantidad)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralDolar: function(){

        let total = [];

        Object.entries(this.detalleDeFactura).forEach(([key, val]) => {
            total.push(parseInt(val.precioDolar)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      promedioTasaDolar: function(){
        var sumatoriaObjeto = this.facturas.reduce(function(acumulador, siguienteValor){
          return {
            tasa: acumulador.tasa + siguienteValor.tasa
          };
        }, {tasa: 0}); //Si no hay nada, regresamos un objeto con edad = 0. No hay necesidad de devolver el nombre, pues no es necesario

        return sumatoriaObjeto.tasa / this.facturas.length;
      },
    },    
    created(){
      this.loadFacturas();
    }
  };
</script>
<style>
 .statscard{
   font-size: 13px;
 }
 .fondotasa{
   background: #f5f5f5;   
   font-weight: bold;
 } 
 .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
 }
 .bckgmontobs{
   background: #e2e6e7;
   font-weight: bold;
 }  
</style>
